export default __webpack_public_path__ + "static/media/promocionAlarma5.a873e590.png";